<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Tipo Productos</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/brand-type-products'" class="m-nav__link">
                        <span class="m-nav__link-text">Tipo Productos</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Tipo Productos
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="['create']"
                                   class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air">
                                    <span>
                                        <i class="la la-plus"></i>
                                        <span>Nuevo tipo producto</span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="m-portlet__body">
                    <div class="table-responsive">
                        <!--begin: Datatable -->
                        <table datatable [dtOptions]="dtOptions"
                               class="table table-striped- table-bordered table-hover table-checkable">
                            <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Marca</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody *ngIf="type_products?.length != 0">
                            <tr *ngFor="let item of type_products">
                                <td>{{ item.name }}</td>
                                <td>
                                    <div *ngIf="item.group_type_product">
                                        <div class="m-0" *ngFor="let datos of item.group_type_product">
                                            <p>{{ datos.brand.name }}</p>
                                        </div>
                                    </div>
                                    <div *ngIf="!item.group_type_product">
                                        <p>No asignado</p>
                                    </div>
                                </td>
                                <td>
                                    <button [routerLink]="['edit', item.id]"
                                            class="m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                            title="Edit details">
                                        <i class="la la-edit"></i>
                                    </button>
                                    <button (click)="delete(item)"
                                            class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill"
                                            title="Delete"> <i class="la la-trash"></i> </button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody *ngIf="type_products?.length == 0">
                            <tr>
                                <td colspan="5" class="no-data-available">No data!</td>
                            </tr>
                            <tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
